import moment from "moment";

const BOOKED_OUT_SITE_ID = 0;
const EXTERNAL_STORAGE_SITE_ID = 9;

const getInstanceLogisticsStatus = (move, now = moment()) => {
  if (move?.siteId === BOOKED_OUT_SITE_ID) {
    return { kind: "booked-out", label: "Booked Out" };
  }
  if (move?.siteId === EXTERNAL_STORAGE_SITE_ID) {
    return { kind: "external-storage", label: "External Storage" };
  }
  if (move?.siteId != null) {
    return { kind: "at-location", label: "At location" };
  }

  const shipment = move?.shipment;
  if (shipment?.delivered) {
    return { kind: "delivered", label: "Delivered" };
  }
  if (shipment?.dispatched) {
    return { kind: "in-transit", label: "In transit" };
  }
  if (
    shipment?.id &&
    shipment?.date &&
    moment.parseZone(shipment.date).isAfter(now, "day")
  ) {
    return { kind: "upcoming", label: "Upcoming shipment" };
  }
  if (shipment?.id) {
    return { kind: "location-unconfirmed", label: "Location unconfirmed" };
  }

  return { kind: "unlocated", label: "Location unknown" };
};

const getInstanceLocationDisplay = move => {
  const logisticsStatus = getInstanceLogisticsStatus(move);

  if (["booked-out", "external-storage"].includes(logisticsStatus.kind)) {
    return {
      detail: null,
      detailLabel: null,
      primary: logisticsStatus.label,
      summary: logisticsStatus.label,
    };
  }

  if (logisticsStatus.kind !== "at-location") {
    return {
      detail: null,
      detailLabel: null,
      primary: logisticsStatus.label,
      summary: logisticsStatus.label,
    };
  }

  const primary = move?.site?.name || "Site unknown";
  const viewingRoom = move?.location?.viewingRoom?.description;
  const location = move?.location?.description;
  const detail = location || viewingRoom || "Location pending";
  const detailLabel = location
    ? "Location"
    : viewingRoom
      ? "Viewing room"
      : "Location";

  return {
    detail,
    detailLabel,
    primary,
    summary: `${primary} · ${detail}`,
  };
};

export { getInstanceLocationDisplay };
export default getInstanceLogisticsStatus;
